module.exports = __webpack_public_path__ + "static/img/page04.12fbe3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page04.jpg
// module id = 69Vs
// module chunks = 0